
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.56 16.602h-.487v2.983h2.29l.31-.488H17.56v-2.495zm-6.681.147l-1.787 2.836h.59l.54-.857h1.152l.302-.487h-1.152l.628-.982 1.47 2.326h.59l-1.802-2.843c-.11-.185-.406-.185-.531.007zm3.463.34h2.049l.302-.488-2.366.002c-.823 0-1.365.667-1.365 1.49s.542 1.49 1.365 1.49l2.002-.001.313-.484h-2.3c-.555 0-.88-.45-.88-1.005 0-.555.325-1.005.88-1.005zm-10.457-.486H1.773c-.823 0-1.365.667-1.365 1.49s.542 1.49 1.365 1.49h2.112c.823 0 1.365-.667 1.365-1.49s-.542-1.49-1.365-1.49zm0 2.495H1.773c-.555 0-.88-.45-.88-1.005 0-.555.325-1.005.88-1.005h2.112c.555 0 .88.45.88 1.005 0 .555-.325 1.005-.88 1.005zm16.324-.768h2.58l.311-.488h-2.89c.084-.432.388-.754.855-.754h2.05l.302-.487-2.366.002c-.824 0-1.365.667-1.365 1.49s.541 1.491 1.365 1.491l2.001-.002.314-.484h-2.3c-.474 0-.778-.327-.857-.768zm-12.182.043a.885.885 0 100-1.77l-2.484-.001v2.983h.546v-2.497h1.938a.4.4 0 110 .8H6.473l1.753 1.693h.706l-1.255-1.207.35-.001z","fill":"#98A3B3"}}),_c('path',{attrs:{"d":"M15.636.81H8.192a6.404 6.404 0 00-.007 12.81h7.451a6.405 6.405 0 100-12.81zm-.163 10.553H8.356a4.148 4.148 0 010-8.295h7.117a4.147 4.147 0 110 8.295z","fill":"#98A3B3"}})])
          )
        }
      }
    